import i18n, { InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import { initReactI18next } from 'react-i18next';
import commonEN from 'translations/en/common.json';
import commonNL from 'translations/nl/common.json';

export const i18nConfig: InitOptions = {
  fallbackLng: 'en',
  debug: false,
  load: 'languageOnly',
  ns: ['common'],
  defaultNS: 'common',
  supportedLngs: ['en', 'nl'],
  resources: {
    en: {
      common: commonEN
    },
    nl: {
      common: commonNL
    }
  },
  detection: {
    order: [
      'navigator',
      'querystring',
      'cookie',
      'localStorage',
      'sessionStorage',
      'htmlTag',
      'path',
      'subdomain'
    ]
  },
  interpolation: {
    escapeValue: false
  },
  returnObjects: true
};

i18n
  .use(LanguageDetector)
  .use(intervalPlural)
  .use(initReactI18next)
  .init({
    ...i18nConfig
  });

export default i18n;
